import React, { FC } from 'react'

const ScoreboardCardContent: FC<{ title: string; subtext: string; customColor?: string }> = ({
	title,
	subtext,
	customColor,
}) => (
	<div className='flex flex-col justify-between h-full ml-3'>
		<span
			className={`tracking-wide text-2xl font-semibold ${customColor ? customColor : 'text-[#0d2d30] dark:text-white'}`}
		>
			{title}
		</span>
		<span
			className={`text-sm font-extralight ${customColor ? customColor : 'text-[#0d2d30] dark:text-white'}`}
		>
			{subtext}
		</span>
	</div>
)

export default ScoreboardCardContent
